import { render, staticRenderFns } from "./ManagerCard.vue?vue&type=template&id=01563316"
import script from "./ManagerCard.vue?vue&type=script&lang=js"
export * from "./ManagerCard.vue?vue&type=script&lang=js"
import style0 from "./ManagerCard.vue?vue&type=style&index=0&id=01563316&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports